export function getCrossOpacity(timeEllapsed: number) {
  if (timeEllapsed < 5) {
    return 1;
  }
  return Math.round(Math.max(1 + (5 - timeEllapsed) * 0.2, 0) * 10) / 10;
}
